import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';

import { createAppSlice } from '../create-app-slice';
import { crmLoadProject } from '@external';
import { Project } from './types';
import { stateInitializer } from './state-initializer';

export type LoadProjectPayload = {
	email: string;
	useTestContact?: boolean;
};

export const loadProject = createAsyncThunk(
	'project/loadProject',
	async (payload: string | LoadProjectPayload, { rejectWithValue, extra }) => {
		const { getToken } = extra as { getToken: () => Promise<string> };
		const email = typeof payload === 'string' ? payload : payload.email;
		const useTestContact = typeof payload === 'string' ? false : payload.useTestContact;
		const [project, error] = await crmLoadProject({ email, useTestContact, getToken });
		if (error) return rejectWithValue(error);
		return project;
	}
);

// If you are not using async thunks you can use the standalone `createSlice`.
export const slice = createAppSlice({
	name: 'project',
	// `createSlice` will infer the state type from the `initialState` argument
	initialState: stateInitializer(),
	// The `reducers` field lets us define reducers and generate associated actions
	reducers: (create) => ({
	}),
	extraReducers: (builder) => {
		builder
			.addCase(loadProject.pending, (state) => {
				console.log('state:loadProject:pending');
				state.splice(0, state.length);
				// state[0].totalPaymentRecieved = 0;
				// state[0].dealStage = '';
				// state[0].depositDocument = '';
				// state[0].blueprintApprovalDocument = '';
				// state[0].blueprintLiaison.email = '';
				// state[0].blueprintLiaison.firstName = '';
				// state[0].blueprintLiaison.lastName = '';
				// state[0].designer.email = '';
				// state[0].designer.firstName = '';
				// state[0].designer.lastName = '';
				// state[0].projectManager.email = '';
				// state[0].projectManager.firstName = '';
				// state[0].projectManager.lastName = '';
			})
			.addCase(loadProject.fulfilled, (state, action: PayloadAction<any>) => {
				console.log('state:loadProject:fulfilled');
				if (!action.payload) return;
				state.splice(0, state.length);
				action.payload.forEach((project: Project) => {
					state.push({
						totalPaymentRecieved: project.totalPaymentRecieved,
						contactId: project.contactId,
						dealId: project.dealId,
						dealName: project.dealName ?? '',
						dealStage: project.dealStage,
						address: project.address,
						city: project.city,
						state: project.state,
						zip: project.zip,
						depositLink: project.depositLink,
						depositDocument: project.depositDocument,
						blueprintApprovalDocument: project.blueprintApprovalDocument,
						recordId: project.recordId,
						paymentType: project.paymentType,
						installationTimeline: project.installationTimeline,
						timeline: project.timeline,
						blueprintLiaison: {
							email: project.blueprintLiaison?.email ?? '',
							firstName: project.blueprintLiaison?.firstName ?? '',
							lastName: project.blueprintLiaison?.lastName ?? ''
						},
						designer: {
							email: project.designer?.email ?? '',
							firstName: project.designer?.firstName ?? '',
							lastName: project.designer?.lastName ?? ''
						},
						projectManager: {
							email: project.projectManager?.email ?? '',
							firstName: project.projectManager?.firstName ?? '',
							lastName: project.projectManager?.lastName ?? ''
						}
					});
				});
			})
			.addCase(loadProject.rejected, (state) => {
				console.log('state:loadProject:rejected');
			});
	},
	// You can define your selectors here. These selectors receive the slice
	// state as their first argument.
	selectors: {
		projectState: (state) => state
	}
});
